module.exports = __webpack_public_path__ + "static/media/Barclays.ab2198ee.png";